<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       x="0px" y="0px"
       :viewBox="viewBox"
       :aria-labelledby="iconName"
       role="presentation" :fill="iconColor">
    <title v-if="tooltip" :id="iconName" lang="en">{{tooltip}}</title>
    <slot />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    viewBox: {
      type: String,
      default: '0 0 100 100',
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: '#bf4e30',
    },
    tooltip: {
      type: String,
    }
  },
};
</script>

<style scoped>
  svg {
    display: inline-block;
    vertical-align: baseline;
    margin-bottom: -2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/IconBase.vue